import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import {
  Feature,
  Permission,
  ReachProSupportCaseClient,
  SubmitNoteFeedbackRequest,
} from 'src/WebApiController';

export function useSubmitNoteFeedback() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const hasReachProSupportFeature = useUserHasFeature(Feature.ReachProSupport);
  const hasSupportCreatePermission = useUserHasAnyOfPermissions(
    Permission.SellerSupportCase_Create
  );

  return useMutation({
    mutationFn: async (vars: SubmitNoteFeedbackRequest) => {
      if (!hasReachProSupportFeature || !hasSupportCreatePermission) {
        return;
      }

      return tryInvokeApi(
        async () => {
          await new ReachProSupportCaseClient(
            activeAccountWebClientConfig
          ).submitNoteFeedback(vars);
        },
        (error) => {
          trackError('ReachProSupportCaseClient.submitNoteFeedback', error);
        }
      );
    },
  });
}
